export default __webpack_public_path__ + "static/media/exorcism.a8ccc034.png";